import { render, staticRenderFns } from "./AcceptOrRejectAskedQuote.vue?vue&type=template&id=ab4f13d4&scoped=true&"
import script from "./AcceptOrRejectAskedQuote.vue?vue&type=script&lang=js&"
export * from "./AcceptOrRejectAskedQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4f13d4",
  null
  
)

export default component.exports